import { DEV } from 'solid-js'
import type { MountainEntity } from '../../../core/entity/EntityType/Mountain'
import type { TilePositionMinMax } from '../../../core/tile_position_xy/getTilePositionMinMax'
import Unexpected from '../../../Exception/Unexpected.class'
import { VERTICES_PER_TILE } from '../../consts'
import TiledInwardPointedMountainGeometry from '../mesh/TiledInwardPointedMountainGeometry.class'

// const terrainMinZ = -2

export default async function createMountainTerrainGeometryV2(
  // engine : Engine,
  mountainEnts: Array<MountainEntity>,
  tpmm: TilePositionMinMax,
  // midPoint: TilePositionXY,
) {
  // console.log('createMountainTerrainGeometryV2', performance.now())

  if (DEV) {
    if (mountainEnts.length === 0) {
      throw new Unexpected('mountainEnts.length === 0')
    }
  }

  const mapWidth = (tpmm.maxX - tpmm.minX) + 1
  const mapHeight = (tpmm.maxY - tpmm.minY) + 1

  const geometry = new TiledInwardPointedMountainGeometry({
    ox: tpmm.minX,
    oy: tpmm.minY,
    width: mapWidth,
    height: mapHeight,
    segments: 48,
    tileSize: VERTICES_PER_TILE,
    ents: mountainEnts,
    // mp: midPoint,
  })
  // geometry.computeVertexNormals()

  // const positionAttribute = geometry.getAttribute('position')
  // positionAttribute.needsUpdate = true

  // geometry.computeVertexNormals() // <-- fixed "black mountain" bug without visual change.
  // // probably these are good for something also
  // geometry.computeBoundingBox()
  // geometry.computeBoundingSphere()

  return geometry
}
